import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { InputNumberComponent } from './number/input-number.component';
import { InputSelectComponent } from './select/input-select.component';
import { InputTextComponent } from './text/input-text.component';
import { InputTextAreaComponent } from './text-area/input-text-area.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AntModule } from '../ant/ant.module';
import { InputDatepickerComponent } from './datepicker/input-datepicker.component';
import { InputRangepickerComponent } from './rangepicker/input-rangepicker.component';
import { InputTreeSelectComponent } from './tree-select/input-tree-select.component';
import { InputCascaderComponent } from './cascader/input-cascader.component';
import { InputTaimepickerComponent } from './taimepicker/input-taimepicker.component';
import { TransferComponent } from './transfer/transfer.component';
import { CheckboxComponent } from './checkbox/checkbox.component';

@NgModule({
  declarations: [
    InputNumberComponent,
    InputSelectComponent,
    InputTextComponent,
    InputTextAreaComponent,
    InputRangepickerComponent,
    InputDatepickerComponent,
    InputTreeSelectComponent,
    InputCascaderComponent,
    InputTaimepickerComponent,
    TransferComponent,
    CheckboxComponent,
  ],
  imports: [CommonModule, PipesModule, FormsModule, ReactiveFormsModule, AntModule],
  exports: [
    InputNumberComponent,
    InputSelectComponent,
    InputTextComponent,
    InputTextAreaComponent,
    InputRangepickerComponent,
    InputDatepickerComponent,
    InputCascaderComponent,
    InputTaimepickerComponent,
    InputTreeSelectComponent,
    TransferComponent,
    CheckboxComponent,
  ],
})
export class InputModule {}
